import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../Button/Button';
import './LandingHero.css';

const LandingHero = () => {
  return (
    <header className="landing-hero-section">
      <h1 className="landing-hero-title">Write Better, Translate Faster, Ship Smoother.</h1>
      <p className="landing-hero-subtitle">
        Texta streamlines your team's writing, translation, and localization workflow.
      </p>
      {/* Container for action buttons */}
      <div className="hero-actions">
        <Link to="/signup" className="landing-hero-cta-link">
          <Button variant="primary" size="xlarge">
            Start translating now
          </Button>
        </Link>
      </div>
      <p className="hero-pricing-caption">$75.00 / month</p>
    </header>
  );
};

export default LandingHero; 